/* eslint-disable camelcase */
import {SetStateAction, useEffect, useState, useCallback} from 'react';
import * as React from 'react';
import {logClkReport} from '@/utils/ubcUtils';
import {VALUE_TYPE} from '@/dicts/consts';
import {NaviChildItem, TopicModule} from '../../../services/pages/channel/channel.client';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    infos: TopicModule;
    moduleId?: string;
    childModuleId?: string;
    onItemClick?: (moduleId: string, childModuleId: string) => void;
    channelBusinessLine?: string;
}

const SelfNaviH = ({infos, moduleId, childModuleId, onItemClick, page, channelBusinessLine}: Props) => {

    const [selectModuleId, setSelectModuleId] = useState<string>();
    const [selectChildModuleId, setChildModuleId] = useState<string>();
    const [naviItems, setNaviItems] = useState<NaviChildItem[]>();

    useEffect(
        () => {
            setSelectModuleId(moduleId);
            setChildModuleId(childModuleId);
            moduleId && document.getElementById(`NaviHId${moduleId}`)?.scrollIntoView(
                {behavior: 'auto'}
            );
        },
        [moduleId, childModuleId]
    );

    useEffect(
        () => {
            const list: SetStateAction<NaviChildItem[]> = [];
            // eslint-disable-next-line no-unused-expressions
            infos.itemList && infos.itemList.length ? infos.itemList[0].fieldValue?.showModuleList?.map(
                // eslint-disable-next-line array-callback-return
                module => {
                    list.push({
                        checked: module.checked,
                        expand: module.expand,
                        moduleId: module.moduleId,
                        title: module.title,
                        child: false,
                    });
                    /* module.children && module.children?.map(
                        child => {
                            list.push({
                                checked: child.checked,
                                expand: child.expand,
                                moduleId: child.moduleId,
                                parentModulId: module.moduleId,
                                title: child.title,
                                child: true
                            });
                        }
                    ) */
                }
            ) : null;
            setNaviItems(list);
        },
        [infos]
    );

    const handlenaviItemClick = useCallback(
        naviItem => {
            if (naviItem.child) {
                setSelectModuleId(naviItem.parentModulId);
                setChildModuleId(naviItem.moduleId);
                onItemClick && naviItem.parentModulId
            && onItemClick(naviItem.parentModulId, naviItem.moduleId);
            } else {
                setSelectModuleId(naviItem.moduleId);
                setChildModuleId('');
                onItemClick && onItemClick(naviItem.moduleId, '');
            }
            logClkReport(
                page,
                'jump_daohang',
                infos.channelId,
                channelBusinessLine,
                infos.moduleId,
                infos.moduleName,
                {
                    value_type: VALUE_TYPE.ITEM,
                    value_id: naviItem.moduleId,
                    value_title: naviItem.title,
                }
            );
        },
        [channelBusinessLine, infos.channelId, infos.moduleId, infos.moduleName, onItemClick, page]
    );


    return (
        <div
            className={styles.parent}
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_daohang',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >
            <img
                onClick={() => {}}
                src={'https://med-fe.cdn.bcebos.com/specialDisease/%20tuberculosis/scienceNavis.png'}
                className={styles.imgCard}
            />
            <div
                className={styles.container}
            >
                {
                    naviItems?.map(
                        naviItem => (
                            // eslint-disable-next-line react/jsx-key
                            <div
                                key={naviItem.moduleId}
                                data-show={JSON.stringify({
                                    'page': page,
                                    'value': 'jump_daohang',
                                    'pageSourceId': infos.channelId,
                                    'pageType': channelBusinessLine,
                                    'valueId': naviItem.moduleId,
                                    'valueTitle': naviItem.title,
                                    'valueType': VALUE_TYPE.ITEM,
                                })}
                            >
                                <div
                                    id={`NaviHId${naviItem.moduleId}`}
                                    onClick={() => handlenaviItemClick(naviItem)}
                                    className={
                                        // eslint-disable-next-line eqeqeq
                                        (naviItem.moduleId == selectModuleId
                                            // eslint-disable-next-line eqeqeq
                                            || naviItem.moduleId == selectChildModuleId
                                        )
                                            ? styles.selectTitleContent
                                            : styles.defaultTitleContent
                                    }
                                >
                                    <span
                                        className={
                                            // eslint-disable-next-line eqeqeq
                                            (naviItem.moduleId == selectModuleId
                                                // eslint-disable-next-line eqeqeq
                                                || naviItem.moduleId == selectChildModuleId
                                            )
                                                ? styles.selectTitle
                                                : styles.defaultTitle
                                        }
                                    >
                                        {
                                            naviItem.title
                                        }
                                    </span>

                                </div>

                            </div>
                        ))
                }

            </div>
        </div>
    );
};

export default SelfNaviH;
